const tabs = [
  {
    key: 'hoy',
    label: 'Hoy',
    icon: (
      <path d="M12 3l8 6v11a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1V9l8-6z" />
    ),
  },
  {
    key: 'calendario',
    label: 'Calendario',
    icon: (
      <path d="M7 2v2M17 2v2M4 8h16M5 5h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zM8 12h3M13 12h3M8 16h3" />
    ),
  },
  {
    key: 'desafios',
    label: 'Desafios',
    icon: (
      <path d="M6 3v18M6 4h11l-2.5 3.5L17 11H6" />
    ),
  },
  {
    key: 'perfil',
    label: 'Perfil',
    icon: (
      <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21c1.6-3.6 4.8-6 8-6s6.4 2.4 8 6" />
    ),
  },
]

function BottomNav({ active, onChange }) {
  return (
    <nav className="bottom-nav" aria-label="Navegacion principal">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`bottom-nav-item ${active === tab.key ? 'active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            {tab.icon}
          </svg>
          <span>{tab.label}</span>
        </button>
      ))}
    </nav>
  )
}

export default BottomNav
